import { useQuery } from '@tanstack/react-query';
import { IDP_LABELS, ORG_ALLOWED_IDPS, type InvitationPreview, type OrgAllowedIdp } from '@grc/types';
import { apiFetch } from '../../lib/api.js';

export const SSO_PROVIDERS = ORG_ALLOWED_IDPS.map((id) => ({
  id,
  label: `Continue with ${IDP_LABELS[id]}`,
}));

/** Providers an org allows, in display order (null = all). */
export function allowedProviders(allowedIdps: string[] | null): OrgAllowedIdp[] {
  return ORG_ALLOWED_IDPS.filter((p) => allowedIdps === null || allowedIdps.includes(p));
}

export function idpLabel(idp: string): string {
  return IDP_LABELS[idp as OrgAllowedIdp] ?? idp;
}

/** The invitation token in `/invitations/accept?token=…`, or null for any other path. */
export function invitationTokenFrom(path: string): string | null {
  try {
    const url = new URL(path, window.location.origin);
    if (url.pathname !== '/invitations/accept') return null;
    const token = url.searchParams.get('token');
    return token && token.length >= 10 ? token : null;
  } catch {
    return null;
  }
}

/** Public lookup of a live invitation by token; a 404 means invalid/expired. */
export function useInvitationPreview(token: string | null) {
  return useQuery({
    queryKey: ['invitation-preview', token],
    queryFn: () =>
      apiFetch<InvitationPreview>(`/auth/invitation?token=${encodeURIComponent(token!)}`),
    enabled: !!token,
    retry: false,
    staleTime: 60_000,
  });
}
